<template>
  <div class="box">
    <div class="section">
      <!-- 菜单 -->
      <div id="contextmenu" v-show="menuVisible" class="menu">
        <div class="contextmenu__item" @click="MainMenuHandleCommand('setpass')">
          <i class="el-icon-key menu_item_icon"></i>修改密码
        </div>
        <div class="contextmenu__item" @click="MainMenuHandleCommand('about')">
          <i class="el-icon-info menu_item_icon"></i>关于...
        </div>
        <div class="contextmenu__item" @click="MainMenuHandleCommand('logout')">
          <i class="el-icon-circle-close menu_item_icon"></i>退出系统
        </div>
      </div>
      <!-- 顶部导航栏  class="d-flex jc-center ai-center navigation" :lg="19" :xs="24"-->
      <div class="header">
        <el-row class="navigation" type="flex" justify="center">
          <el-col>
            <div class="d-flex ai-center jc-between">
              <span class="d-flex ai-center">
                <img class="m-1" src="@/assets/logo.png" alt="" width="45" />
                <span class="ml-2 websitetitle">
                  <div>{{ SystemName }}</div>
                </span>
              </span>
              <span v-if="user != ''" :style="userInfoStyle" class="d-flex ai-center jc-end title">
                <span class="fs-md">你好，{{ user.name }}！</span>
                <span class="menuIco mr-1" @click="menuIconClick" @click.stop="menuVisible == true">
                  <el-avatar>
                    {{ user.name === "" ? "登录" : user.name[0] }}
                  </el-avatar>
                </span>
              </span>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 主体 :lg="18" :xs="24" class="main" :style="bodyStyle"-->
      <el-container style="min-height: calc(100vh - 95px)">
        <el-aside style="width: 220px; border-right: solid 1px #e6e6e6;">
          <el-menu :default-openeds="['1', '2', '3', '4']" :default-active="menuActive" @select="menuSelect"
            background-color="#b3c0d1" text-color="#333" active-text-color="red">
            <el-submenu index="1" v-if="userRoles.isSuper" class="fs-xs">
              <template slot="title">
                <div class="iconfont icon-gongdanluru"> 工单办理</div>
              </template>
              <!-- 系统管理员操作项 -->
              <el-menu-item index="1-1" v-if="userRoles.isSuper">
                <div class="iconfont icon-gongdanliebiao1"> 工单列表</div>
              </el-menu-item>
              <!-- <el-menu-item index="1-5" v-if="userRoles.isSuper">舆情导入</el-menu-item> -->
              <el-menu-item index="1-4" v-if="userRoles.isSuper">
                <div class="iconfont icon-ziyuan1442"> 工单审查 </div>
              </el-menu-item>
              <el-menu-item index="1-2" v-if="userRoles.isSuper">
                <div class="iconfont icon-gongdanzhuanban"> 工单转办 </div>
              </el-menu-item>
              <el-menu-item index="1-3" v-if="userRoles.isSuper">
                <div class="iconfont icon-shencha"> 答复审核 </div>
              </el-menu-item>

            </el-submenu>
            <!--  -->
            <el-submenu index="2" v-if="userRoles.isManager || userRoles.isSuper">
              <template slot="title">
                <div class="iconfont icon-gongdanluru2"> 工单办理 </div>
              </template>
              <!-- 单位管理员操作项 -->
              <el-menu-item index="2-0" v-if="userRoles.isManager || userRoles.isSuper">
                <div class="iconfont icon-gongdanliebiao"> 工单列表</div>
              </el-menu-item>
              <!-- <el-menu-item index="2-4" v-if="userRoles.isSuper">
                网络工单
              </el-menu-item> -->
              <el-menu-item index="2-3" v-if="userRoles.isSuper">
                <div class="iconfont icon-gongdanluru2"> 工单录入</div>
              </el-menu-item>
              <el-menu-item index="2-1" v-if="userRoles.isManager">
                <div class="iconfont icon-caidanlanshebeiweibaoguanliicon"> 工单办理</div>
              </el-menu-item>
              <el-menu-item index="2-2" v-if="userRoles.isManager">
                <div class="iconfont icon-xitongguanli_yonghuguanli"> 补充佐证</div>
              </el-menu-item>
            </el-submenu>
            <!--  -->
            <el-submenu index="3">
              <template slot="title">
                <!-- <i class="el-icon-message"></i> -->
                <div class="iconfont icon-wangluocanshu"> 网站配置</div>
              </template>
              <el-menu-item index="3-1" v-if="userRoles.isSuper || userRoles.isAdmin">
                <div class="iconfont icon-yonghuguanli"> 用户管理</div>
              </el-menu-item>
              <el-menu-item index="3-2" v-if="userRoles.isAdmin">
                <div class="iconfont icon-xitongcanshu"> 系统参数</div>
              </el-menu-item>
              <el-menu-item index="3-4" v-if="userRoles.isAdmin">
                <div class="iconfont icon-wangluopaqu"> 网络爬取参数</div>
              </el-menu-item>
              <el-menu-item index="3-3">
                <div class="iconfont icon-mimashezhi"> 密码设置</div>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">
                <div class="iconfont icon-kuozhanshuxing"> 扩展功能</div>
              </template>
              <el-menu-item index="4-1" v-if="userRoles.isSuper">
                <div class="iconfont icon-shencha"> AI舆情分析 </div>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-container>
          <router-view />
        </el-container>
      </el-container>
    </div>
    <!-- 页脚 -->
    <div class="footer">
      <el-row type="flex" justify="center">
        <el-col :lg="19" :xs="24">
          <!-- <hr /> -->
          <div class="foot-content">
            <span class="m-2 text-red fs-md">{{ MaintenanceUnitName }}</span>
            <span class="m-2 text-grey hidden-sm-and-down fs-md">{{
              SystemName
            }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    //恢复左边菜单选项
    // if (this.$store.state.actionMenu) {
    //   this.menuActive = this.$store.state.actionMenu;
    // }
  },
  async created() {
    var res = await this.pstApi.getWebsiteParameters();
    if (!(res.status && res.status == 200)) {
      console.log("网站参数读取失败");
      return "";
    } else {
      //系统参数获取成功后设置系统参数
      var parameters = res.data;
      this.pstApi.setWebsiteParameters(parameters);
    }
    // 设置网页标题
    window.document.title = this.SystemTitle;

    var userRoles = this.pstApi.getUserRoles();
    this.userRoles = userRoles;
    //console.log("roles:", this.userRoles);
    if (userRoles == null) {
      this.$router.push({ name: "Login" });
      return;
    }
    if (userRoles.isAdmin || userRoles.isSuper) {
      this.menuActive = "1-1";
    } else if (userRoles.isManager) {
      this.menuActive = "2-0";
    } else if (userRoles.isUser) {
      this.menuActive = "3-3";
    }
    this.menuSelect(this.menuActive, "");

    let user = this.pstApi.getUserData();
    if (user != null) {
      this.user = user;
    }
  },
  data() {
    return {
      // 菜单
      menuVisible: false,
      menuActive: "3-3",
      userInfoStyle: {
        whiteSpace: "nowrap",
        width: "150px",
      },
      user: "",
      userRoles: "",
      //
      outHeight: 100,
      bodyStyle: {
        overflowY: "auto",
        overflowX: "hidden",
        listStyle: "none",
        height: 500 + "px",
      },
    };
  },
  methods: {
    //选项菜单选择事件
    menuSelect(activeIndex, path) {
      this.menuActive = activeIndex;
      this.$store.commit("setActionId", activeIndex);
      switch (activeIndex) {
        case "1-1":
          this.$router.push({ name: "PstQuery" });
          break;
        case "1-2":
          this.$router.push({ name: "Transfers" });
          break;
        case "1-3":
          this.$router.push({ name: "ReplyAudits" });
          break;
        case "1-4":
          this.$router.push({ name: "PstAudits" });
          break;
        case "1-5":
          this.$router.push({ name: "Import" });
          break;

        case "2-0":
          this.$router.push({ name: "HandleQuery" });
          break;
        case "2-1":
          this.$router.push({ name: "Replys" });
          break;
        case "2-2":
          this.$router.push({ name: "Evidences" });
          break;
        case "2-3":
          this.$router.push({ name: "Negatives" });
          break;
        case "2-4":
          this.$router.push({ name: "PstCrawlers" });
          break;
        case "3-1":
          this.$router.push({ name: "Supers" });
          break;
        case "3-2":
          this.$router.push({ name: "Parameter" });
          break;
        case "3-3":
          this.$router.push({ name: "Password" });
          break;
        case "3-4":
          this.$router.push({ name: "CrawlerParam" });
          break;
        //扩展功能
        case "4-1":
          this.$router.push({ name: "AIAnalysis" });
          break;
        default:
          break;
      }
    },
    // 菜单公用方法
    menuIconClick(event) {
      this.menuVisible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
      this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏
      event.preventDefault(); //关闭浏览器右键默认事件
      var menu = document.querySelector(".menu");

      this.styleMenu(menu);
    },
    foo() {
      // 取消鼠标监听事件 菜单栏
      this.menuVisible = false;
      document.removeEventListener("click", this.foo); // 关掉监听
    },
    styleMenu(menu) {
      var avatar = document.querySelector(".menuIco");
      var posLeft = avatar.getBoundingClientRect().right;
      var posTop = avatar.getBoundingClientRect().bottom;
      // console.log(posLeft,posTop);
      document.addEventListener("click", this.foo); // 给整个document新增监听鼠标事件，点击任何位置执行foo方法
      var clientWidth = document.documentElement.clientWidth;
      posLeft = clientWidth - posLeft > 130 ? posLeft - 50 : clientWidth - 140;
      menu.style.left = posLeft + "px";
      menu.style.top = posTop + "px";
    },

    //框架主下拉菜单命令
    MainMenuHandleCommand(command) {
      if (command == "setpass") {
        this.selected = "my";
        //this.$store.commit("setActionId", this.selected);
        this.$router.push({ name: "Password" });
      }
      if (command == "about") {
        this.selected = "my";
        //this.$store.commit("setActionId", this.selected);
        this.$router.push({ name: "About" });
      }
      if (command == "logout") {
        //清除服务器token缓存
        this.userApi
          .logout()
          .then(() => {
            this.$toast("登出成功");
            console.log("logout");
            window.sessionStorage.removeItem("UserData");
            window.sessionStorage.clear();
            this.$router.push({ name: "Home" });
          })
          .catch(() => {
            console.log("err");
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.navigation {
  width: 100%;
  z-index: 1000;
  // height: 60px;
  background-color: #333744;
}

.welcometext {
  margin-right: 10px;
  font-size: 14px;
  color: #9e9b9b;
}

.title {
  // width: 100%;
  // height: 50px;
  color: white;
  // line-height: 30px;
}

.main {
  width: 100%;
}

// 菜单样式
.custom-menu {
  font-size: 12px;
}

.contextmenu__item {
  padding-left: 15px;
  display: block;
  line-height: 34px;
  text-align: left;
}

.contextmenu__item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.menu_item_icon {
  margin-right: 5px;
  width: 20px;
  height: 20px;
}

.menu {
  position: fixed;
  top: 45px;
  //position: absolute;
  //
  background-color: #fff;
  width: 120px;
  /*height: 106px;*/
  font-size: 14px;
  color: #444040;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  white-space: nowrap;
  z-index: 20000;
}

.menuIco {
  cursor: pointer;
}

.contextmenu__item:hover {
  cursor: pointer;
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

//
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
  // background-color: #000;
  //height: 100vh;
}

/deep/ .el-menu-item,
.el-submenu__title {
  height: 40px;
  line-height: 40px;
  position: relative;
  // -webkit-box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
  // background-color: #000;
}

.el-submenu .el-menu-item,
.el-submenu__title {
  height: 40px;
  line-height: 40px;
  text-align: left;
  // background-color: #000;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 15px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: white;
}
</style>